import { render, staticRenderFns } from "./addmatches.vue?vue&type=template&id=0e8570b7&scoped=true&"
import script from "./addmatches.vue?vue&type=script&lang=js&"
export * from "./addmatches.vue?vue&type=script&lang=js&"
import style0 from "./addmatches.vue?vue&type=style&index=0&id=0e8570b7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8570b7",
  null
  
)

export default component.exports